import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "../../../hooks";
import {
  Button,
  InputsFormPure,
  TooltipFormPure,
  FormError,
  ButtonHLPure,
} from "../../pures";
import { Grid } from "@material-ui/core";
import "./reliable-signature-personal-data.css";

const ReliableSignaturePersonalDataView = (props) => {
  const { user, validator, selectedStep } = props;
  const {
    firstName,
    firstLastName,
    secondLastName,
    cellphoneNumber,
    phoneNumber,
    address,
    curp,
    rfc,
  } = user;
  const { street, colony, state, township, zipCode } = address;
  const { t } = useTranslation();
  const {
    form,
    touch,
    validations,
    onHandleChange,
    onHandleTouch,
    onHandleValidate,
    onValidateForm,
  } = useForm({
    firstName,
    firstLastName,
    secondLastName,
    cellphoneNumber,
    phoneNumber,
    street,
    colony,
    state,
    township,
    zipCode,
    curp,
    rfc,
  });

  const { step, onHandleBack, onHandleNext } = props;
  const { next, back } = step;

  const onChange = (event, validator) => {
    const { name, value } = event.target;
    onHandleChange(name, value);
    touch[name] && onHandleValidate(name, value, validator);
  };

  const onBlur = (event, validator) => {
    const { name, value } = event.target;
    onHandleValidate(name, value, validator);
    onHandleTouch(name, value);
  };

  const onHandleSubmit = () => {
    const result = onValidateForm(form, validator);
    if (!Object.keys(result).length) {
      onHandleNext(form, selectedStep + 1);
    }
  };

  const onBack = () => onHandleBack(form, selectedStep - 1);

  return (
    <div className="card-description-reliable">
      <Grid container>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <TooltipFormPure
            title={t("signatureRequestView2.tooltipClic")}
            tooltipTitle={t("register.personalData.name")}
            tooltipDescription={t(
              "relialeSignaturePersonalData.tooltipDescriptionName"
            )}
            text={t("register.personalData.name")}
          />
          <InputsFormPure
            type="text"
            id="firstName"
            name="firstName"
            minLength={2}
            value={form.firstName}
            onChange={(event) => onChange(event, validator.firstName)}
            onBlur={(event) => onBlur(event, validator.firstName)}
          />
          {validations.firstName && (
            <FormError message={t("reliableSignaturePersonalData.errorName")} />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="firstLastName"
            name="firstLastName"
            minLength={2}
            title={t("register.personalData.firstLastName")}
            value={form.firstLastName}
            onChange={(event) => onChange(event, validator.firstLastName)}
            onBlur={(event) => onBlur(event, validator.firstLastName)}
          />
          {validations.firstLastName && (
            <FormError
              message={t("reliableSignaturePersonalData.errorFirstLastName")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="secondLastName"
            name="secondLastName"
            minLength={2}
            title={t("register.personalData.secoundLastName")}
            value={form.secondLastName}
            onChange={(event) => onChange(event, validator.secondLastName)}
            onBlur={(event) => onBlur(event, validator.secondLastName)}
          />
          {validations.secondLastName && (
            <FormError
              message={t("reliableSignaturePersonalData.errorSecondLastName")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <TooltipFormPure
            title={t("signatureRequestView2.tooltipClic")}
            tooltipTitle={t("relialeSignaturePersonalData.tooltipCURP")}
            tooltipDescription={t(
              "relialeSignaturePersonalData.tooltipDescriptionCURP"
            )}
            text={t("reliableSignaturePersonalData.curp")}
          />
          <InputsFormPure
            type="text"
            id="curp"
            name="curp"
            minLength={2}
            value={form.curp}
            onChange={(event) => onChange(event, validator.curp)}
            onBlur={(event) => onBlur(event, validator.curp)}
          />
          {validations.curp && (
            <FormError message={t("reliableSignaturePersonalData.errorCURP")} />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="cellphoneNumber"
            name="cellphoneNumber"
            minLength={2}
            title={t("reliableSignaturePersonalData.cellphone")}
            value={form.cellphoneNumber}
            onChange={(event) => onChange(event, validator.cellphoneNumber)}
            onBlur={(event) => onBlur(event, validator.cellphoneNumber)}
          />
          {validations.cellphoneNumber && (
            <FormError
              message={t("reliableSignaturePersonalData.errorCellphoneNumber")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="rfc"
            name="rfc"
            minLength={2}
            title={t("reliableSignaturePersonalData.rfc")}
            value={form.rfc}
            onChange={(event) => onChange(event, validator.rfc)}
            onBlur={(event) => onBlur(event, validator.rfc)}
          />
          {validations.rfc && (
            <FormError message={t("reliableSignaturePersonalData.errorRFC")} />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            minLength={2}
            title={t("reliableSignaturePersonalData.phoneNumber")}
            value={form.phoneNumber}
            onChange={(event) => onChange(event, validator.phoneNumber)}
            onBlur={(event) => onBlur(event, validator.phoneNumber)}
          />
          {validations.phoneNumber && (
            <FormError
              message={t("reliableSignaturePersonalData.errorPhoneNumber")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <TooltipFormPure
            title={t("signatureRequestView2.tooltipClic")}
            tooltipTitle={t("reliableSignaturePersonalData.streetAndNumber")}
            tooltipDescription={t(
              "relialeSignaturePersonalData.tooltipDescriptionStreet"
            )}
            text={t("reliableSignaturePersonalData.streetAndNumber")}
          />
          <InputsFormPure
            type="text"
            id="street"
            name="street"
            minLength={2}
            value={form.street}
            onChange={(event) => onChange(event, validator.street)}
            onBlur={(event) => onBlur(event, validator.street)}
          />
          {validations.street && (
            <FormError
              message={t("reliableSignaturePersonalData.errorStreet")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="colony"
            name="colony"
            minLength={2}
            title={t("reliableSignaturePersonalData.neighborhood")}
            value={form.colony}
            onChange={(event) => onChange(event, validator.colony)}
            onBlur={(event) => onBlur(event, validator.colony)}
          />
          {validations.colony && (
            <FormError
              message={t("reliableSignaturePersonalData.errorColony")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="township"
            name="township"
            minLength={2}
            title={t("reliableSignaturePersonalData.delegacionMunicipio")}
            value={form.township}
            onChange={(event) => onChange(event, validator.township)}
            onBlur={(event) => onBlur(event, validator.township)}
          />
          {validations.township && (
            <FormError
              message={t("reliableSignaturePersonalData.errorTownship")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="state"
            name="state"
            minLength={2}
            title={t("reliableSignaturePersonalData.estado")}
            value={form.state}
            onChange={(event) => onChange(event, validator.state)}
            onBlur={(event) => onBlur(event, validator.state)}
          />
          {validations.state && (
            <FormError
              message={t("reliableSignaturePersonalData.errorState")}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} className="form-element">
          <InputsFormPure
            type="text"
            id="zipCode"
            name="zipCode"
            minLength={2}
            title={t("reliableSignaturePersonalData.zipCode")}
            value={form.zipCode}
            onChange={(event) => onChange(event, validator.zipCode)}
            onBlur={(event) => onBlur(event, validator.zipCode)}
          />
          {validations.zipCode && (
            <FormError
              message={t("reliableSignaturePersonalData.errorZipCode")}
            />
          )}
        </Grid>
      </Grid>
      <div className="ReliableSignaturePersonalDataView-action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleSubmit}
        />
      </div>
    </div>
  );
};

export default ReliableSignaturePersonalDataView;
